var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.7 7.8",
    style: {
      enableBackground: "new 0 0 13.7 7.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#BF5F13;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,7.8c-0.2,0-0.5-0.1-0.6-0.3l-6-6C-0.1,1.3,0,0.7,0.1,0.4l0.1-0.1l0.1-0.1c0.2-0.1,0.5-0.1,0.6-0.1 s0.4,0,0.6,0.1h0.1L7,5.6l5.3-5.3C12.4,0.1,12.6,0,12.8,0s0.5,0.1,0.6,0.3c0.2,0.2,0.3,0.4,0.3,0.6s-0.1,0.5-0.3,0.6l-6,6 C7.3,7.7,7.1,7.8,6.8,7.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,0.6c0.2-0.1,0.6-0.1,0.8,0l0,0l5.6,5.6l5.6-5.6c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-6,6 C7,7.5,6.7,7.5,6.5,7.3l0,0l-6-6C0.4,1.2,0.4,0.8,0.5,0.6L0.5,0.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBrown);
export default __webpack_public_path__ + "static/media/chevron_down_brown.1568b5852806d72e6f5c0bf1573e9d28.svg";
export { ForwardRef as ReactComponent };